import { __, sprintf } from '@wordpress/i18n';
import { getPricingPlan } from '../../helpers';

const Hero = ({ isEventActive, eventExpired }) => {
    let maxPct = 0;
    try {
        const pricingPlan = getPricingPlan();
        if (pricingPlan) {
            ['basic', 'professional', 'agency'].forEach((k) => {
                const p = pricingPlan[k];
                if (!p) return;
                const val = Number(p.discount) || 0;
                if (val > 0 && (p.discount_type === 'percentage' || !p.discount_type)) {
                    if (val > maxPct) maxPct = val;
                }
            });
        }
    } catch (e) {
        // ignore
    }

    const title = isEventActive && maxPct > 0
        ? sprintf(__('Upgrade to Pro and Save Up to %s%%', 'jeg-elementor-kit'), maxPct)
        : __('Affordable Pricing Plan', 'jeg-elementor-kit');

    const subtitle = isEventActive && maxPct > 0
        ? sprintf(__('Maximize your website’s potential with advanced widgets and demos. Upgrade today and unlock all premium features with up to %s%% off', 'jeg-elementor-kit'), maxPct)
        : __('Maximize your website\'s potential with advanced widgets and demos. Upgrade to PRO and go further.', 'jeg-elementor-kit');

    return (
        <div className="f-pricing__hero">
            <h2 className="f-pricing__title">{title}</h2>
            <p className="f-pricing__subtitle">{subtitle}</p>
        </div>
    );
};

export default Hero;
